import { createFileRoute } from '@tanstack/react-router'
import { VeiculoCategoriasPage } from '@/pages/veiculo-categorias/VeiculoCategoriasPage'

export const Route = createFileRoute('/_auth/veiculo-categorias')({
  component: VeiculoCategoriasPage,
})
